import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import useGa from 'Client/hooks/useGa';
import { useSegmentTracking } from 'Common/segment';

const useAppTracking = () => {
    const gaTracking = useGa();
    const { p100HotjarTracker } = useFeatureToggle();
    const { track } = useSegmentTracking();

    const trackAppWideVariations = () => {
        const relevantFeatureToggles: Record<string, boolean | undefined> = { p100HotjarTracker };
        gaTracking.trackVariation('p100HotjarTracker', p100HotjarTracker);
        track('App Wide Feature Toggles Evaluated', relevantFeatureToggles);
    };

    return {
        trackAppWideVariations,
    };
};

export default useAppTracking;
